module.exports = __webpack_public_path__ + "img/map.05876e72.png";